import { getCachedOrgBranding } from './orgBrandingCache';

/** Organization display name from login session / branding cache. */
export function getOrganizationName() {
  if (typeof window === 'undefined') return '';

  try {
    const cached = getCachedOrgBranding();
    if (cached?.name) return cached.name;
  } catch {
    /* ignore */
  }

  try {
    const raw = localStorage.getItem('organization_details');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed?.name && String(parsed.name).trim()) {
        return String(parsed.name).trim();
      }
    }
  } catch {
    /* ignore */
  }

  return '';
}
